import React from 'react';
import { motion } from 'framer-motion';
import { FaCheck, FaArrowRight } from 'react-icons/fa';

const Pricing = () => {
    const features = [
        "Kompletna arhitektura baze znanja",
        "Integracija: Instagram + Meta + Web",
        "24/7 Monitoring & AI Optimizacija",
        "Mesečni izveštaj o automatizaciji",
        "Podrška za Serbian B2B ton"
    ];

    return (
        <section id="cenovnik" className="py-20 md:py-32 bg-black">
            <div className="max-w-6xl mx-auto px-4">
                <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-12 bg-gray-900/50 backdrop-blur-xl border border-white/10 rounded-[2.5rem] p-8 md:p-12 overflow-hidden relative">
                    <div className="absolute top-0 right-0 w-64 h-64 bg-blue-600/5 rounded-full -mr-32 -mt-32 blur-3xl" />

                    <div className="flex-1 relative z-10">
                        <h2 className="text-3xl md:text-5xl font-bold mb-6 italic text-white">Paketi koji se isplate već u prvom mesecu.</h2>
                        <div className="space-y-4 mb-8">
                            {features.map((feature, idx) => (
                                <div key={idx} className="flex items-center gap-3 text-gray-300">
                                    <FaCheck className="text-blue-500 shrink-0" />
                                    <span>{feature}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="w-full md:w-80 bg-white/5 rounded-3xl p-8 border border-white/10 text-center relative z-10 backdrop-blur-sm">
                        <div className="text-gray-400 text-sm uppercase tracking-widest font-bold mb-2">Paketi od</div>
                        <div className="text-5xl font-black mb-2 text-white">350€<span className="text-xl font-normal text-gray-500">/mes</span></div>
                        <div className="text-sm text-blue-400 font-bold mb-8">+ setup fee</div>

                        <button
                            onClick={() => document.getElementById('kontakt')?.scrollIntoView({ behavior: 'smooth' })}
                            className="w-full py-4 bg-blue-600 text-white rounded-xl font-bold flex items-center justify-center gap-2 hover:bg-blue-700 transition-all group"
                        >
                            Vidi detalje
                            <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
                        </button>
                        <p className="mt-4 text-[10px] text-gray-500 italic">Preporučeno za shopove sa 500+ upita mesečno.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Pricing;
